import type { DepositSource, UpsertDepositSourceDto } from 'api/btlApplicationForm/types';
import { DepositSourceType } from 'api/btlApplicationForm/types';

export const BROKER_DEPOSIT_SOURCE_TYPES = Object.values(DepositSourceType).filter(
  (type): type is Exclude<DepositSourceType, DepositSourceType.UNKNOWN> => type !== DepositSourceType.UNKNOWN,
);

export type DepositSourceFormValue = {
  id?: string;
  sourceType?: DepositSourceType;
  amount?: number;
  description?: string | null;
};

export function calculateDepositAmount(
  purchasePrice: number | null | undefined,
  financingAmount: number | null | undefined,
): number {
  if (typeof purchasePrice !== 'number' || typeof financingAmount !== 'number') {
    return 0;
  }

  return Math.max(0, purchasePrice - financingAmount);
}

export function mapDepositSourceTypeToFormValue(
  sourceType: DepositSourceType,
): Exclude<DepositSourceType, DepositSourceType.UNKNOWN> | undefined {
  return sourceType === DepositSourceType.UNKNOWN ? undefined : sourceType;
}

export function mapDepositSourcesToFormValues(depositSources: DepositSource[] | undefined): DepositSourceFormValue[] {
  if (!depositSources?.length) {
    return [];
  }

  return depositSources.map(source => ({
    id: source.id,
    sourceType: mapDepositSourceTypeToFormValue(source.sourceType),
    amount: source.amount,
    description: source.description,
  }));
}

export function normalizeDepositSourcesForSubmit(
  depositSources: DepositSourceFormValue[] | undefined,
): UpsertDepositSourceDto[] {
  if (!Array.isArray(depositSources) || !depositSources.length) {
    return [];
  }

  return depositSources.map(source => {
    const normalized: UpsertDepositSourceDto = {
      sourceType: source.sourceType ?? DepositSourceType.UNKNOWN,
      amount: Number(source.amount) || 0,
      description: source.description || null,
    };

    if (source.id) {
      normalized.id = source.id;
    }

    return normalized;
  });
}
